<style lang="scss" scoped>
.success-factor {
    @media (min-width: 768px) {
        max-width: 282px;
    }
}
.subtitle {
    line-height: 1;
}
.icon {
    line-height: 1;
    color: var(--accent);
}
.success-factors-row {
    display: flex;
    flex-flow: wrap;
    margin: 0 -12px;
    .static-card, .gift-card {
        padding: 0 12px;
        flex-grow: 1;
        flex: none;
    }
}
::v-deep .tns-ovh {
    overflow: visible;
}
</style>

<template>
    <div class="container">
        <div v-if="title" class="mb-40 d-flex flex-wrap w-100">
            <h3 v-if="title" v-html="title" class="title"></h3>
        </div>

        <slide-y-down-transition group class="success-factors-row row mb-n40 mb-lg-0" tag="div">
            <div class="col-12 col-md-6 mb-40 mb-lg-0 col-lg-4" v-for="(item,index) in successFactors" :key="index">
                <div class="success-factor">
                    <span class="icon d-block mb-24"><i :class="item.icon"></i></span>
                    <span class="subtitle d-inline-block mb-8">{{ item.title }}</span>
                    <p class="font-weight-light">{{ item.description }}</p>
                </div>
            </div>
        </slide-y-down-transition>
    </div>
</template>

<script>
import row from "../mixins/row";
import { SlideYDownTransition } from 'vue2-transitions'

export default {
    name: "pagePart.success-factors-row",

    mixins: [row],

    components: { SlideYDownTransition },

    props: {
        itemsPerRow: {
            type: Number,
            default: null,
        },
        successFactors: {
            type: Array,
            required: true,
            default: () => {
                return [];
            },
        },
    },

    data: (vm) => ({
        show: false,
        fixedHeight: null,
    }),

    mounted() {
        this.show = true;
    },

    computed: {
        item_count() {
            if (this.itemsPerRow) return this.itemsPerRow
            if (this.successFactors.length > 5) return 6;
            return this.successFactors.length
        },
        lastItemDivision() {
            const index = this.successFactors.length
            if (index % this.item_count === 0) return this.item_count

            return 100 / ((this.item_count - (index % this.item_count - 1)) / this.item_count * 100)
        }
    }
}
</script>